var _rect, _g, _rect2, _g2, _path, _path2, _path3, _line, _line2, _line3, _path4, _path5, _path6, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlCmdBaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2018_4280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 23,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.1992,
    y: 23.9932,
    width: 18.0073,
    height: 18.0073,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2018_4280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3556 33.4845H22.1758V32.5091H30.3556L26.5131 28.6666L27.2028 27.9697L32.2298 32.9968L27.2028 38.0238L26.5131 37.3269L30.3556 33.4845Z",
    fill: "#4ED064"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2018_4280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 23,
    width: 19,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0073,
    height: 18.0073,
    transform: "matrix(-1 0 0 1 21.8008 23.9932)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2018_4280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64441 33.4845H17.8242V32.5091H9.64441L13.4869 28.6666L12.7972 27.9697L7.77016 32.9968L12.7972 38.0238L13.4869 37.3269L9.64441 33.4845Z",
    fill: "#4ED064"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 0.5C19.0144 0.500188 20.4089 1.88199 20.4092 3.56641C20.4092 5.25103 19.0146 6.6336 17.2734 6.63379C15.5321 6.63379 14.1367 5.25115 14.1367 3.56641C14.137 1.88188 15.5323 0.5 17.2734 0.5Z",
    stroke: "#DFD8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77637 16.5079C4.86594 16.0359 5.27845 15.6943 5.75884 15.6943H13.2412C13.7215 15.6943 14.1341 16.0359 14.2236 16.5079L15 20.5988H4L4.77637 16.5079Z",
    stroke: "#DFD8D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91016 15.6051L14.092 4.0127M15.4556 6.42399L12.7283 15.6051",
    stroke: "#DFD8D0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 8.16116,
    y2: -0.5,
    transform: "matrix(0.933352 0.358961 -0.371169 0.928565 20.0859 3.56738)",
    stroke: "#DFD8D0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 8.16116,
    y2: -0.5,
    transform: "matrix(0.933352 0.358961 -0.371169 0.928565 19.0898 6.05762)",
    stroke: "#DFD8D0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7.15243,
    y2: -0.5,
    transform: "matrix(-0.371169 0.928565 -0.933352 -0.358961 28.6992 4.00586)",
    stroke: "#DFD8D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2106 6.45104L33.0977 5.2177L36.251 9.54333",
    stroke: "#DFD8D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4613 8.31947L30.1914 12.4823L35.5017 11.4118",
    stroke: "#DFD8D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 24.5222L3 21.5986C3 21.0463 3.44772 20.5986 4 20.5986L15 20.5986C15.5523 20.5986 16 21.0463 16 21.5986L16 24.5222",
    stroke: "#4ED064"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 24.4688,
    x2: 40,
    y2: 24.4688,
    stroke: "#DFD8D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlCmdBaseIcon);
export default __webpack_public_path__ + "static/media/control-cmd-base-icon.d8406f8ffdea9b3c3f121e49a7c149f0.svg";
export { ForwardRef as ReactComponent };